<script setup lang="ts">
import { NSpace } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch'
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between' | 'space-evenly'
  vertical?: boolean
  size?: 'small' | 'medium' | 'large' | number | [number, number]
  wrap?: boolean
  itemStyle?: string | object
  separator?: string | object
}>(), {
  align: undefined,
  justify: 'start',
  vertical: false,
  size: 'medium',
  wrap: true,
  itemStyle: undefined,
  separator: undefined,
})

const attrs = useAttrs()
</script>

<template>
  <NSpace
    :align="align"
    :justify="justify"
    :vertical="vertical"
    :size="size"
    :wrap="wrap"
    :item-style="itemStyle as string"
    :separator="separator"
    v-bind="attrs"
  >
    <slot />
  </NSpace>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
